import { CloseOutlined } from "@ant-design/icons";
import { Flex, Switch, Typography } from "antd";
import React from "react";
import { useAppSelector } from "../../hooks/redux-hooks";
import { useRecordFirst } from "../../hooks/useRecordFirst";
import useSpecialityReference from "../../hooks/useSpecialityReference";
import { LC_KEYS } from "../../utils/constants";

/**
 * One-time introduction to record-first, anchored bottom-right. Dismissing it is
 * remembered per browser; toggling from here writes the same preference as Settings.
 */
const RecordFirstPopover = () => {
  const { sessionTermLower } = useSpecialityReference();
  const { isDemoPath, isMobilePath } = useAppSelector((state) => state.appState);
  const recordFirst = useRecordFirst();
  const [dismissed, setDismissed] = React.useState(
    () => localStorage.getItem(LC_KEYS.RECORD_FIRST_INTRO_SEEN) === "true",
  );

  const dismiss = () => {
    localStorage.setItem(LC_KEYS.RECORD_FIRST_INTRO_SEEN, "true");
    setDismissed(true);
  };

  if (dismissed || isDemoPath || isMobilePath) {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        right: 24,
        bottom: 24,
        zIndex: 1000,
        width: 248,
        padding: 16,
        background: "#fff",
        border: "1px solid #e2e8f0",
        borderRadius: 12,
        boxShadow: "0px 25px 50px -12px rgba(0, 0, 0, 0.25)",
      }}
    >
      <Flex align="flex-start" justify="space-between">
        <span style={{ padding: "2px 8px", borderRadius: 6, background: "#dcfce7", color: "#00c950", fontSize: 11 }}>
          New
        </span>
        <CloseOutlined onClick={dismiss} style={{ color: "#90a1b9", cursor: "pointer" }} aria-label="Dismiss" />
      </Flex>
      <Typography.Paragraph style={{ margin: "8px 0", fontSize: 12 }}>
        <Typography.Text strong style={{ fontSize: 12 }}>
          Record your {sessionTermLower}s first and add details later.
        </Typography.Text>{" "}
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          You can always change this in Session settings.
        </Typography.Text>
      </Typography.Paragraph>
      <Flex
        align="center"
        justify="space-between"
        style={{ padding: "4px 8px", border: "1px solid #e2e8f0", borderRadius: 8 }}
      >
        <Typography.Text style={{ fontSize: 12 }}>{recordFirst.enabled ? "Turn off" : "Turn on"}</Typography.Text>
        <Switch
          size="small"
          checked={recordFirst.enabled}
          loading={recordFirst.saving}
          onChange={recordFirst.setEnabled}
        />
      </Flex>
    </div>
  );
};

export default RecordFirstPopover;
